"use client";

import useSWR from "swr";

import SWR_KEYS from "@/constants/swr-keys";
import IServiceQueue from "@/interfaces/service-queue.interface";
import serviceQueueService from "@/services/service-queue.service";
import { ByIdRequestProps, RequestsBaseReturn } from "@/types/requests.types";

export type Return = RequestsBaseReturn<IServiceQueue | null>;

export type Props = ByIdRequestProps;

type UseSwrGetServiceQueueByIdParams = [string, number];

const useGetServiceQueueById = ({ _id }: Props): Return => {
  const fetcher = useSWR<IServiceQueue, Error, UseSwrGetServiceQueueByIdParams | null>(
    _id ? [SWR_KEYS.getServiceQueueById, _id] : null,
    ([, serviceQueueId]) => serviceQueueService.getById(serviceQueueId),
    { revalidateOnFocus: false, shouldRetryOnError: false, errorRetryCount: 0 }
  );

  const { data = null, isValidating: isLoading, error } = fetcher;

  return { data, isLoading, error };
};

export default useGetServiceQueueById;
